module.exports = __webpack_public_path__ + "img/1521397330.42ed2542.jpg";